/**
 * VisionSLVisionPageView
 *
 * Page component for VisionSLVisionPageView
 * Path: /sl/vision
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { VisionSLVisionPageView as __VisionSLVisionPageView } from '@/components/traits/VisionSLVisionPageView';
import { VisionSLVisionAnalyticsView as __VisionSLVisionAnalyticsView } from '@/components/traits/VisionSLVisionAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface VisionSLVisionPageViewProps {
  // Add any page-level props here
}

export function VisionSLVisionPageView(_props: VisionSLVisionPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-vision:meta.title"],"description":["i18n/t","std-almadar-vision:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/vision"},{"locale":"ar","path":"/ar/vision"},{"locale":"sl","path":"/sl/vision"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__VisionSLVisionPageView config={{ initPayload: __navState }} />
          <__VisionSLVisionAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default VisionSLVisionPageView;
